export const getApiHost = (includeProtocol = true) => {
    var hostname = document.location.hostname;

    if (hostname.includes('local.hotjar.com')) {
        hostname += ':8443';
    }

    if (includeProtocol) {
        return `https://${hostname}`;
    }

    return hostname;
};
